import React from 'react'
import {motion, useAnimation} from 'framer-motion'
import Image from 'next/image'

import {t} from '@lib/helpers'
import {logEvent} from '@lib/gtm'

export const Why = ({animationProps, scrollTo}) => {
  const controls = useAnimation()
  React.useEffect(() => {
    const element = document.querySelector('.DataLabeling__why')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])
  return (
    <motion.div
      className='DataLabeling__why'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__why__container'>
        <div className='DataLabeling__why__container__img'>
          <div className='DataLabeling__why__container__img__bg1' />
          <div className='DataLabeling__why__container__img__bg2' />
          <Image
            alt='Data Labeling'
            src='/images/services/data-labeling/why.png'
            width='452px'
            height='662px'
            priority
          />
        </div>
        <div className='DataLabeling__why__container__content'>
          <h2>
            Why Leading Companies <br />
            Choose<span> Data Wow?</span>
          </h2>

          <div className='DataLabeling__why__container__content__list'>
            {Array(5)
              .fill('')
              .map((item, idx) => (
                <ul
                  key={idx}
                  className='DataLabeling__why__container__content__list__item'
                >
                  <li>
                    <div className='icon'>
                      <Image
                        alt='Data Labeling'
                        src='/images/services/data-labeling/check.svg'
                        width='22px'
                        height='22px'
                      />
                    </div>
                    <div
                      className='item'
                      dangerouslySetInnerHTML={{
                        __html: t(`pages.dataLabeling.why.data.${idx}`),
                      }}
                    />
                  </li>
                </ul>
              ))}
          </div>
          <div className='DataLabeling__why__container__content__iso'>
            <Image
              className='iso-logo'
              alt='Data Labeling'
              src='/images/iso/pm722313.png'
              width='133px'
              height='80px'
            />
            <Image
              className='iso-logo'
              alt='Data Labeling'
              src='/images/iso/pm744494.png'
              width='133px'
              height='80px'
            />
          </div>
          <motion.a
            {...animationProps(0.2)}
            href='#contact'
            onClick={(e) => {
              scrollTo(e)
              logEvent({
                ga: {
                  category: 'Data Labeling',
                  action: 'Action: Click CTA',
                },
              })
            }}
            className='DataLabeling__why__container__content__button'
          >
            {t('pages.dataLabeling.why.button')}
          </motion.a>
        </div>
      </div>
    </motion.div>
  )
}
